<template>
    <div v-if="!selectedDonationFrequency" class="flex justify-between w-full border-interactive-9 rounded-[4px] bg-white overflow-hidden items-center p-1 box-border">
        <div class="skeleton-loader flex-1 first:mr-1 first:ml-0 mr-0 ml-1 h-7 text-center p-2.5 rounded-[4px] hover:bg-primary-1 hover:text-white cursor-pointer group" v-for="i in 2" :key="i"></div>
    </div>
    <div v-else class="w-full flex border border-interactive-9 rounded-[4px] bg-white overflow-hidden">
        <div
            v-for="frequency in donationFrequencies"
            class="w-1/2 flex items-center justify-center h-8 cursor-pointer text-sm uppercase"
            :class="[selectedDonationFrequency.id === frequency.id ? 'bg-primary-1 text-white' : '']"
            @click="switchSection(frequency)"
        >
            {{ frequency.frequency_label }}
        </div>
    </div>
</template>

<script setup>
import {useDonationStore} from "@/store/useDonationStore";
import {storeToRefs} from "pinia";

const {selectedDonationFrequency, donationFrequencies} = storeToRefs(useDonationStore());

function switchSection(section) {
    selectedDonationFrequency.value = section;
}
</script>